/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/


/* Product Page - Filter Subscriptions */
if ($('.subscription-options-container').length) {
  $('.subscription-option').click(function(e) {
    var $option = $(e.currentTarget);
    if (!$option.hasClass('active')) {
      $option.find('.subscription-option__radio').prop('checked',true).trigger('change');
    }
  });
  $('.subscription-option__radio').change(function(e) {
    var $radio = $(e.currentTarget);
    var $productSingle = $radio.closest('.product-single__box');
    var isFilter = false;
    if ($productSingle.hasClass('filter-zw')) {
      isFilter = true;
      var $price = $('.price__text');
    }
    $('.subscription-option').removeClass('active');
    $radio.closest('.subscription-option').addClass('active');
    if ($radio.val() == 'subscription') {
      $('.js-product-form').find(':submit').hide();
      $('.js-product-form').find('.subscription-add').show();
      $('.subscription-details').slideDown('fast');
      $('.buy-button-wrapper').hide();
      if (isFilter) {
        // ensure the 4-pack of filters is selected and hide the variant swatches
        $('variant-radios .product-form__swatch__input[value="4 Pack"]').prop('checked',true);
        $('.product-single__box__block--variant_picker').slideUp('fast');
        const event = new Event("change", {
          view: window,
          bubbles: true,
          cancelable: true
        });
        $('variant-radios')[0].dispatchEvent(event);
        var productPriceStr = $price.find('.price__number .money').html();
        var salePriceStr = '£'+$('.subscription-option__details .amount-recurring').html();
        $price.find('.price__number').addClass('price__number--sale').find('.money').html(salePriceStr);
        $price.find('.price__compare').remove();
        $price.append('<s class="price__compare"><span class="money">'+productPriceStr+'</span></s>');
        
      }
    } else {
      $('.js-product-form').find(':submit').show();
      $('.js-product-form').find('.subscription-add').hide();
      $('.subscription-details').slideUp('fast');
      $('.buy-button-wrapper').show();
      if (isFilter) {
        var productPriceStr = $price.find('.price__compare .money').html();
        $('.product-single__box__block--variant_picker').slideDown('fast');
        $price.find('.price__number').removeClass('price__number--sale');
        $price.find('.price__number .money').html(productPriceStr);
        $price.find('s.price__compare').remove();
      }
    }
  })
  $('.subscription-selling-plan').change(function(e) {
    var $selectedOption = $(e.currentTarget).find(':selected');
    var frequency = $selectedOption.data('frequency');
    console.log("frequency",frequency);
    console.log("initial-price",$selectedOption.data('initial-price'));
    console.log("recurring-price",$selectedOption.data('recurring-price'));
    $('.subscription-option__details .amount-initial').html($selectedOption.data('initial-price'));
    $('.subscription-option__details .amount-recurring').html($selectedOption.data('recurring-price'));
    $('.subscription-option__details .frequency').html(frequency == 1?'month':frequency+' months');
  })
  
  var $productForm = $('.js-product-form');
  $productForm.on('click', '.subscription-add', function(e) {
    // Check if the first radio button is checked and an option is selected
    if ($('.subscription-option__radio:checked').val() == 'subscription') {
      e.preventDefault();
      // Get the selected option of the select with subscription plans
      var $selectedOption = $('.subscription-selling-plan').find(':selected');
      // Get the variant ID and selling plan ID
      var variantId = $selectedOption.data('product-id');
      var sellingPlanId = $selectedOption.data('selling-plan-id');
      // Create the data object for the AJAX post request
      var data;
      if ($('.product-single__box').hasClass('filter-zw')) {
        // Subscribing from a filter page adds only the subscription to the cart, not the standalone product
        data = {
          "items": [
            {
              "id": variantId,
              "quantity": $('.product-form__qty-input').find('input').val(),
              "selling_plan": sellingPlanId
            }
          ]
        };
      } else {
        data = {
          "items": [
            {
              "id": variantId,
              "quantity": $('.product-form__qty-input').find('input').val(),
              "selling_plan": sellingPlanId
            },
            {
              "id": $productForm.data('variant-id'),
              "quantity": $('.product-form__qty-input').find('input').val()
            }
          ]
        };
      }
  
      var $button = $(e.currentTarget);
      $button.removeClass('is-added').addClass('is-adding');
      // Perform the AJAX post request to add the selected subscription plan to the cart
      
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: JSON.stringify(data),
        contentType: 'application/json',
        dataType: 'json',
        success: function() {
          $button.removeClass('is-adding').addClass('is-added');
          $productForm.find(".subscription-add")[0].addEventListener("animationend", function() {
            $button.removeClass('is-added');
          });
          
          // Fetch the updated cart and update the store
          fetchCart().then(updatedCart => {
            window.theme.cart.store.setState({ products: updatedCart });

            theme.mfpOpen('cart')
            
          }).catch(error => {
            console.error('Failed to update the cart:', error);
          });
        },
        error: function() {
          $button.removeClass('is-added is-adding');
        }
      });
    } 
  });

  function fetchCart() {
    return fetch('/cart.js')
      .then(response => response.json())
      .then(cart => cart)
      .catch(error => {
        console.error('Error fetching cart:', error);
        throw error;
      });
  }
  
  function deDupeItemsInCart(cart) {
    let itemMap = new Map();
    cart.items.forEach(item => {
      if (itemMap.has(item.id)) {
        itemMap.get(item.id).quantity += item.quantity;
      } else {
        itemMap.set(item.id, { ...item });
      }
    });
    cart.items = Array.from(itemMap.values());
    return cart;
  }
  
  function clearCart() {
    return fetch('/cart/clear.js', { method: 'POST' })
      .then(response => response.json())
      .then(cart => cart)
      .catch(error => {
        console.error('Error clearing cart:', error);
        throw error;
      });
  }
  
  
}
// open collection sidebar on page load
if(window.location.hash && window.location.hash == '#filtered') {
  theme.mfpOpen("collection-draw");
}


/* FAQ */
$('.faq-question').on('click', function(e) {
  $item = $(e.currentTarget).parent('.faq-item');
  $item.toggleClass('active');
  $item.find('.faq-answer').toggle();
})